import React from "react";

function Anchor({
  forMobileNoSpan,
  linkCls,
  iconCls,
  linkText,
  hyperLink,
  linkTarget = "_blank",
  btnState = false,
  extraAttri = {},
}) {
  const iconTag = iconCls ? <i className={iconCls}></i> : "";
  const spanTag = linkText ? <span>{linkText}</span> : "";

  return (
    <>
      <a
        href={hyperLink}
        target={linkTarget}
        rel="noopener noreferrer"
        className={linkCls}
        disabled={btnState}
        {...extraAttri}
      >
        {!forMobileNoSpan && spanTag}
        {iconTag}
      </a>
    </>
  );
}

export { Anchor };
